import { createSlice } from '@reduxjs/toolkit';
import { getFromLocalStorage } from '../utils/localStorage';

const initialState = {
  user: getFromLocalStorage(),
  isLoggedIn: !!getFromLocalStorage(),
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    loginSuccess: (state, action) => {
      state.user = action.payload;
      state.isLoggedIn = true;
    },
    logout: (state) => {
      state.user = null;
      state.isLoggedIn = false;
    },
  },
});

export const { loginSuccess, logout } = authSlice.actions;
export default authSlice.reducer;
